import { render, staticRenderFns } from "./OtherPartyPopupNpr.vue?vue&type=template&id=513148ba"
import script from "./OtherPartyPopupNpr.vue?vue&type=script&lang=ts"
export * from "./OtherPartyPopupNpr.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports